var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconControlMutechat = function SvgIconControlMutechat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-control-mutechat_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.685 0 0 2.685 0 6s2.685 6 6 6h5.22c.43 0 .78-.35.78-.78V6c0-3.315-2.685-6-6-6Zm1.785 6.97a.576.576 0 0 1-.405.985.56.56 0 0 1-.405-.17l-.97-.97-.97.97a.58.58 0 0 1-.405.17.576.576 0 0 1-.405-.985l.97-.97-.97-.97a.576.576 0 0 1 .815-.815l.97.97.97-.97a.576.576 0 0 1 .815.815l-.97.97.97.97h-.01Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-control-mutechat_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgIconControlMutechat;